import { __extends } from "tslib";
import { SearchFacesRequest, SearchFacesResponse } from "../models/models_0";
import { deserializeAws_json1_1SearchFacesCommand, serializeAws_json1_1SearchFacesCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var SearchFacesCommand = /** @class */ (function (_super) {
    __extends(SearchFacesCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function SearchFacesCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    SearchFacesCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "RekognitionClient";
        var commandName = "SearchFacesCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: SearchFacesRequest.filterSensitiveLog,
            outputFilterSensitiveLog: SearchFacesResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    SearchFacesCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1SearchFacesCommand(input, context);
    };
    SearchFacesCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1SearchFacesCommand(output, context);
    };
    return SearchFacesCommand;
}($Command));
export { SearchFacesCommand };
//# sourceMappingURL=SearchFacesCommand.js.map